// Firehose partitions on event_name, so every Capability usage event carries this exact singular value.
export const USED_APPLICATION_CAPABILITY_EVENT_NAME = "used_application_capability";
export const DATABRICKS_EVENT_ENDPOINT = "event";
